import type { FC } from "react";
import "./styles.scss";
const MarkdownRenderer: FC<{ post: { html: string }; customClass?: string | undefined }> = ({
    post,
    customClass = "",
}) => {
    // biome-ignore lint/security/noDangerouslySetInnerHtml: trusted html
    return <section className={`markdown_content ${customClass}`} dangerouslySetInnerHTML={{ __html: post.html }} />;
};

export default MarkdownRenderer;
